export enum EnCookieName {
  CHAPTER_SETTINGS = 'chapterSettings',
  USER_SETTINGS = 'userSettings',
}
